import React from 'react'
import { IonItem, IonLabel, IonIcon } from '@ionic/react'
import { checkmarkSharp, chevronForward } from 'ionicons/icons'
import { BaseSyntheticEvent } from 'react'
import './Item.component.css'

export interface IItem {
  dataTestId: string
  label: string
  showCheckMark?: boolean
  onClick: (e: BaseSyntheticEvent) => void
}

const Item: React.FC<IItem> = (props: IItem) => {
  const { dataTestId, label, showCheckMark, onClick } = props
  return (
    <IonItem lines='none' className='item-start-end-padding' data-testid={dataTestId} onClick={onClick}>
      <IonLabel className='item-label-display' color='medium'>
        <h2>{label}</h2>
        {showCheckMark && <IonIcon size='small' color='success' className='item-check-icon' icon={checkmarkSharp} />}
      </IonLabel>
      <IonIcon
        slot='end'
        size='small'
        className='ion-float-right'
        data-testid={'ChevronForward'}
        icon={chevronForward}
        onClick={onClick}
      />
    </IonItem>
  )
}

export default Item
